module.exports = { id: "speed", url: "/build/app/img/symbols.svg#speed", viewBox: "", toString: function() { return this.url; } };